import '../../assets/css/aboutus.css';
import PageBanner from "../../components/Common/PageBanner";
import DifferenceSection from "./DifferenceSection";
import CountersSection from "./CountersSection";
import LabDiamondSection from "./LabDiamondSection";
import JewelryCarouselSection from "./JewelryCarouselSection";
import ServiceSection from "./ServiceSection";
import SupportSection from "./SupportSection";

export default function AboutUs() {
    document.title = "About Us";
    return (
        <>
            <div className="main-container-aboutus">
                <PageBanner
                    backgroundImage="/assets/images/aboutus/aboutus_banner.png"
                    height="85vh"
                    overlay={false}
                >
                    <h1 className="banner-title fs-1" data-aos="fade-up">The Meera Difference</h1>
                </PageBanner>
                <DifferenceSection />
                <CountersSection />
                <LabDiamondSection />
                <JewelryCarouselSection />
                <ServiceSection />
                <SupportSection />

            </div>
        </>
    );
}